var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"subtitle"},[_vm._v("\n      Drug Information\n    ")]),_vm._v(" "),_c('app-searchbar',{staticClass:"search",on:{"searchDrug":_vm.getDrugInfo}}),_vm._v(" "),(_vm.isActive)?_c('app-drug-info',{attrs:{"drug2":_vm.drug,"allDrugs":_vm.allDrugs,"type":_vm.type,"drugName":_vm.drugName}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03cfd4e7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 24
// module chunks = 0